import React from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

interface CategoryBannerProps {
  onCategorySelect?: (category: string) => void;
}

export function CategoryBanners({ onCategorySelect }: CategoryBannerProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentCategory = searchParams.get('category');

  const categories = [
    { name: 'Kesktase', image: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751277652/kesktase_pxvoh6.jpg', tag: 'Kesktase' },
    { name: 'Pro tase', image: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751277651/protase_cv52nz.jpg', tag: 'Pro tase' },
    { name: 'Street', image: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751277655/street_aqufdo.webp', tag: 'Street' },
    { name: 'Park', image: 'https://res.cloudinary.com/daka2lob2/image/upload/v1751277673/park_uzx0w7.webp', tag: 'Park' },
    { name: 'Lastele', image: 'https://res.cloudinary.com/daka2lob2/image/upload/v1774593569/laste-toukeratas-mini-touks_gsy148.jpg', tag: 'Laste' }
  ];

  const handleCategoryClick = (tag: string) => {
    if (onCategorySelect) {
      onCategorySelect(tag);
    } else {
      if (currentCategory === tag) {
        navigate('/toukeratas');
      } else {
        // Map category tags to new URL paths
        let categoryPath = '';
        if (tag === 'Kesktase') {
          categoryPath = '/toukeratas/kesktase-toukerattad';
        } else if (tag === 'Pro tase') {
          categoryPath = '/toukeratas/pro-tase-toukerattad';
        } else if (tag === 'Street') {
          categoryPath = '/toukeratas/street-toukerattad';
        } else if (tag === 'Park') {
          categoryPath = '/toukeratas/pargi-toukerattad';
        } else if (tag === 'Laste') {
          categoryPath = '/toukeratas/laste-toukeratas';
        } else {
          // Fallback: use query parameter approach
          categoryPath = `/toukeratas?category=${tag}`;
        }
        navigate(categoryPath);
      }
    }
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12">
      {categories.map((category) => (
        <div
          key={category.tag}
          onClick={() => handleCategoryClick(category.tag)}
          className="relative overflow-hidden rounded-lg cursor-pointer group"
        >
          <div className="aspect-[16/9]">
            <img
              src={category.image}
              alt={category.name}
              title={category.name}
              fetchpriority="high"
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/45 flex items-center justify-center">
              <h3 className="text-white text-2xl font-bold">{category.name}</h3>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
